/* eslint-disable no-nested-ternary */
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import SmartPlanSvg from 'Components/common/assets/svgIcons/SmartPlanSvg';
import GlobalButton from 'Components/common/components/GlobalButton';
import {
  IsTablet, getCurrentTime, removeQueryParam, valueToObject,
  accountPlanSocket,
} from 'Utils/UtilityFunctions';
import { Drawer, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  selectAccountFormLoading,
  selectAccountPlanForm, selectAccountPlanIds,
  selectAccountPlanOpen,
  selectAccountPlanStatus,
  selectCurrentSapCompanyId,
  selectGeneratedAccountPlans,
  selectLimitPopupSAP,
  selectuserAccountDetails,
  selectShowSapPreview,
  selectGenerationFail,
  selectSocketAccountPlanStatus,
  selectAccountPlanFailed,
  selectSAPAllowed,
  selectSAPDownloadAllowed,
  selectAetnaSubsidiaryCompanies,
  selectAetnaSubsidiaryCompaniesLoading,
  showAccountHistory,
  showPodcastTab,
} from 'Selector/CompaniesSelector';
import { useSearchParams } from 'react-router-dom';
import {
  maxTablet, primaryColor, primaryFont, primaryHeadingColor, wBold,
  wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import ProfilePopups from 'Components/common/modal/ProfilePopups';
import { SMART_REDIRECTION_TEXT } from 'Utils/Constants';
import { selectPreviewDrawerOpen } from 'Selector/DocumentHubSelector';
import { selectCreateNewSap } from 'Selector/UISelector';
import { actions as uiActions } from 'Slice/UISlice';
import { AccountPlanStatus } from 'Types/CompaniesTypes';
import {
  selectActivetype, selectAiCertificationData, selectHighlight, selectOpenDrawer,
} from 'Selector/CertificationSelector';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { chatStates } from 'Components/layout/headers/NavBarPrimary';
import SmartAccountPlanSlider from './SmartAccountPlanSlider';
import SmartAccountSplashScreen from './SmartAccountSplashScreen';
import SmartAccountPlanPreparingLoader from './SmartAccountPlanPreparingLoader';
import SmartPlanDocumentReady from './SmartPlanDocumentReady';
import SmartAccountAetnaSelection from './SmartAccountAetnaSelection';

const Wrapper = styled.div`
/* position: relative; */ //commented for tooltip alignment fix
.btn-tooltip{
  .ant-tooltip{
    z-index: 0;
    @media (max-width: ${maxTablet}) {
      display: none;
    }
    sup{
      font-weight: ${wBold};
    }
  }
}
.drawer-account-plan {
  padding: 0px 57px 0px 57px;
}
`;
const DisableContent = styled.div`
display: flex;
flex-direction: column;
align-items: center;
color: ${primaryHeadingColor};
font-family: ${primaryFont};
font-size: 14px;
font-weight: ${wMedium};
line-height: 21px;
.support-tooltip-content {
  color: ${primaryColor};
  text-decoration: underline;
}
`;
type Props = {
  companyName: string
  showSAPHierarchy: boolean
  userCompanyId: number
};

const DrawerSmartAccount = function DrawerSmartAccount(props: Props) {
  const { companyName, showSAPHierarchy, userCompanyId } = props;
  const { saveProfileName: saveProfile } = chatStates;
  const isTab = IsTablet();
  const dispatch = useDispatch();
  const visible = useSelector(selectAccountPlanOpen);
  const limitPopup = useSelector(selectuserAccountDetails);
  const showLimitPopupSAP = useSelector(selectLimitPopupSAP);
  const generationFail = useSelector(selectGenerationFail);
  const [showAccountPlanForm, setShowAccountPlanForm] = useState(false);
  const [planGenerated, setPlanGenerated] = useState(false);
  const [drawerViewerOpen, setDrawerViewerOpen] = useState(false);
  const [allowPopup, setAllowPopup] = useState(false);
  const [hasSAPGenerated, setHasSAPGenerated] = useState(false);
  const startTime = getCurrentTime();
  const accountPlanForm = useSelector(selectAccountPlanForm);
  const accountPlanStatus = useSelector(selectAccountPlanStatus);
  const formLoading = useSelector(selectAccountFormLoading);
  const loadingIds = useSelector(selectAccountPlanIds);
  const currentSapCompanyId = useSelector(selectCurrentSapCompanyId);
  const generatedAccountPlans = useSelector(selectGeneratedAccountPlans);
  const showSapPreview = useSelector(selectShowSapPreview);
  const openDocHubPreview = useSelector(selectPreviewDrawerOpen);
  const sapAllowed = useSelector(selectSAPAllowed);
  const sapDownloadAllowed = useSelector(selectSAPDownloadAllowed);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const showAccountPlan = searchParams.get('accountPlan');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const isPreparingLoaderVisible = loadingIds.includes(companyIdParsed);
  const [mappedCompanyId, setMappedCompanyId] = useState(0);
  const effectiveCompanyId = mappedCompanyId || companyIdParsed;
  const hasMappedCompany = !!mappedCompanyId;
  const socketAccountPlanStatus = useSelector(selectSocketAccountPlanStatus);
  const AccountPlanFailed = useSelector(selectAccountPlanFailed);
  const aetnaSubsidiaryCompanies = useSelector(selectAetnaSubsidiaryCompanies);
  const aetnaSubsidiaryCompaniesLoading = useSelector(selectAetnaSubsidiaryCompaniesLoading);
  const showHistorySAP = useSelector(showAccountHistory);
  const showPodcastTabSAP = useSelector(showPodcastTab);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const certificationDrawerOpen = useSelector(selectOpenDrawer);
  const [sapInitialized, setSapInitialized] = useState(false);
  const [aetnaSelectionDismissed, setAetnaSelectionDismissed] = useState(false);
  const needsAetnaResetRef = React.useRef(false);
  const wasPreparingLoaderVisibleRef = React.useRef(false);
  const createNewSapFromGeneration = useSelector(selectCreateNewSap);

  const shouldShowAetnaSelection = showSAPHierarchy
    && !hasMappedCompany
    && !showHistorySAP
    && !showPodcastTabSAP
    && aetnaSubsidiaryCompanies.length > 1 // first company is parent company, so more than 1 means there are subsidiaries
    && !aetnaSelectionDismissed;

  useEffect(() => {
    if (visible && needsAetnaResetRef.current) {
      const isStillLoading = loadingIds.includes(companyIdParsed);
      const planAlreadyGenerated = generatedAccountPlans.some(
        (plan) => plan.companyId === companyIdParsed,
      );
      if (isStillLoading || planAlreadyGenerated) {
        needsAetnaResetRef.current = false;
      } else {
        setMappedCompanyId(0);
        setAetnaSelectionDismissed(false);
        dispatch(actions.setCurrentSapCompanyId(0));
        dispatch(actions.setShowSAPHistory(true));
        dispatch(actions.clearAccountPlanForm());
        needsAetnaResetRef.current = false;
      }
    }
  }, [visible]);

  useEffect(() => {
    if (createNewSapFromGeneration) {
      setMappedCompanyId(0);
      setAetnaSelectionDismissed(false);
      dispatch(actions.setShowSAPHistory(false));
      dispatch(uiActions.createNewSapFromGenerationScreen(false));
    }
  }, [createNewSapFromGeneration]);

  const handleNewAccountPlan = (isBack?: boolean) => {
    setShowAccountPlanForm(false);
    if (!isBack) {
      setMappedCompanyId(0);
    }
    setAetnaSelectionDismissed(!!isBack);
    dispatch(actions.setShowSAPHistory(false));
    dispatch(actions.setNewAccountPlan());
    if (!isBack) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('create_new_account_plan', startTime, {}),
      ));
    }
  };
  useEffect(() => {
    if (currentType === 'company_profile_sap' && visible) {
      handleNewAccountPlan(true);
      dispatch(actions.setShowSAPHistory(false));
    }
  }, [visible]);

  const toggle = () => {
    if (visible) {
      removeQueryParam('accountPlan');
      const planAlreadyGenerated = generatedAccountPlans.some(
        (plan) => plan.companyId === companyIdParsed,
      );
      if (hasSAPGenerated) {
        setMappedCompanyId(0);
        setAetnaSelectionDismissed(false);
        setHasSAPGenerated(false);
      }
      if (loadingIds.includes(companyIdParsed)) {
        needsAetnaResetRef.current = true;
      } else if (currentSapCompanyId === companyIdParsed && planAlreadyGenerated) {
        dispatch(actions.setCurrentSapCompanyId(0));
      } else if (!loadingIds.includes(currentSapCompanyId)) {
        dispatch(actions.setCurrentSapCompanyId(0));
      }
      dispatch(actions.setDocumentDownloadURL({ fileURL: '', fileViewUrl: '', documentId: 0 }));
    } else {
      dispatch(certificationActions.aiCertificationAction({
        type: 'open_sap',
        source: 'sap',
        data: aiCertificationData,
      }));
    }
    if (limitPopup?.showPlanPopup === 3) {
      setShowAccountPlanForm(false);
    }
    dispatch(actions.setAccountPlanDrawerOpen(!visible));
  };

  useEffect(() => {
    if (visible && certificationDrawerOpen) {
      toggle();
    }
  }, [certificationDrawerOpen]);

  useEffect(() => {
    if (allowPopup && limitPopup?.showPlanPopup === 3) {
      dispatch(actions.setAccountPlanDrawerOpen(false));
      dispatch(actions.setShowLimitPopupSAP(true));
      setAllowPopup(false);
    }
  }, [allowPopup, limitPopup?.showPlanPopup]);

  useEffect(() => {
    if (saveProfile && saveProfile.includes(SMART_REDIRECTION_TEXT)) {
      dispatch(actions.setAccountPlanDrawerOpen(true));
    }
  }, [saveProfile]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (shouldShowAetnaSelection) {
        setShowAccountPlanForm(false);
        return;
      }

      if (!formLoading && accountPlanForm.length) {
        setShowAccountPlanForm(true);
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [formLoading, accountPlanForm.length, shouldShowAetnaSelection]);

  useEffect(() => {
    if (!visible) {
      wasPreparingLoaderVisibleRef.current = false;
      return;
    }

    if (isPreparingLoaderVisible) {
      wasPreparingLoaderVisibleRef.current = true;
      return;
    }

    if (wasPreparingLoaderVisibleRef.current) {
      setHasSAPGenerated(true);
      wasPreparingLoaderVisibleRef.current = false;
    }
  }, [visible, isPreparingLoaderVisible]);

  useEffect(() => {
    const generatedSap = generatedAccountPlans.find(
      (plan) => plan.companyId === companyIdParsed,
    );
    setPlanGenerated(!!generatedSap);
    if (generatedSap) {
      setShowAccountPlanForm(false);
      dispatch(actions.setShowSAPHistory(!AccountPlanFailed && true));
      dispatch(actions.getAccountPlanHistory({
        offset: 0,
        sortType: 'date',
        sort: 'des',
        companyId: companyIdParsed,
        type: 'history',
      }));
      setSapInitialized(true);
    }
  }, [generatedAccountPlans]);

  useEffect(() => {
    if (showAccountPlan) {
      dispatch(actions.setAccountPlanDrawerOpen(true));
    }
  }, [showAccountPlan]);

  useEffect(() => {
    if (showAccountPlan) {
      dispatch(actions.setAccountPlanDrawerOpen(true));
    }
  }, [showAccountPlan]);

  // useeEffect for getting Account Plan Status
  const checkAccoutnPlanApiStatus = (res: AccountPlanStatus) => {
    if (res.status === 'Generated') {
      const data = {
        companyId: companyIdParsed,
        url: res?.response,
        previewUrl: res?.viewableResponse,
        sapDocumentId: res?.sapDocumentId,
      };
      dispatch(actions.setAccountPlan(data));
      dispatch(actions.setSmartAccountToastMessage(
        { message: res.message, companyId: companyIdParsed },
      ));
      dispatch(actions.removeAccountPlanId(companyIdParsed));
    } else if (res?.status === 'Failed') {
      dispatch(actions.setGenerationFail());
      dispatch(flurryActions.setNotification({
        message: res.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
        type: 'accountPlan',
        companyId: companyIdParsed,
      }));
      dispatch(actions.removeAccountPlanId(companyIdParsed));
    } else {
      accountPlanSocket.emit('fe_account_plan', {
        accountPlanId: Number(res?.accountPlanId),
        username: localStorage.getItem('email'),
        identifier: 'account_plan',
        environment: 'PROD',
      });
    }
  };

  useEffect(() => {
    socketAccountPlanStatus.map((res) => checkAccoutnPlanApiStatus(res));
  }, [socketAccountPlanStatus]);

  useEffect(() => {
    if (visible && accountPlanStatus === 'In Progress' && !loadingIds.includes(companyIdParsed) && !planGenerated) {
      // dispatch(actions.generateAccountPlan({
      //   companyId: companyIdParsed,
      // }));
    }
    if (visible) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('smart_account_plan', startTime, {
          companyId: companyIdParsed,
        }),
      ));
    }
  }, [visible]);

  useEffect(() => {
    const node = document.querySelector('body');
    return visible ? node?.classList.add('body-drawer-toggle-account-plan') : node?.classList.remove('body-drawer-toggle-account-plan');
  }, [visible]);

  // const handleNewAccountPlan = (isBack?: boolean) => {
  //   setShowAccountPlanForm(false);
  //   dispatch(actions.setNewAccountPlan());
  //   if (!isBack) {
  //     dispatch(flurryActions.callFlurryEvent(
  //       valueToObject('create_new_account_plan', startTime, {}),
  //     ));
  //   }
  // };

  const handleAllowPop = () => {
    setAllowPopup(!allowPopup);
  };

  const tooltipContent = () => (
    <>
      Create Smart Account Plan
      <sup>TM</sup>
    </>
  );
  const disableTooltipContent = () => (
    <DisableContent>
      Currently not available, please contact
      <a className="support-tooltip-content" href="mailto:support@xiqinc.com">support@xiqinc.com</a>
    </DisableContent>
  );

  useEffect(() => {
    if (generationFail) {
      setShowAccountPlanForm(false);
    }
  }, [generationFail]);
  return (
    <Wrapper className="smartAccountWrapper">
      <Tooltip
        placement="bottom"
        getPopupContainer={(e: HTMLElement) => e}
        className={classNames('triggers-bullet-tooltip btn-tooltip', { disabledTooltip: !sapAllowed || !sapDownloadAllowed })}
        color="#fff"
        title={sapAllowed && sapDownloadAllowed ? tooltipContent : disableTooltipContent}
        arrow={false}
      >
        <span className="wrapper-btn">
          <GlobalButton
            title="Smart Account Plan"
            textColor="#ffffff"
            bgColor="#001760"
            RightSpace="12px"
            PaddingSm="5px 10px"
            innerSpace="8px 16px"
            heightSm="30px"
            IconLeft={isTab ? <span /> : <SmartPlanSvg color="#fff" />}
            onButtonClick={toggle}
            // eslint-disable-next-line function-paren-newline
            buttonClassName={classNames('smart-plan-btn',
              { disabled: !sapAllowed || !sapDownloadAllowed || aetnaSubsidiaryCompaniesLoading },
              { highlightedComponent: isHighlight && (currentType === 'company_profile_sap') && !visible },
            )}
          />
        </span>
      </Tooltip>
      <Drawer
        rootClassName={classNames('drawer-alerts smart-account-drawer drawer-account-plan', { nestedDrawerViewer: showSapPreview || drawerViewerOpen || openDocHubPreview })}
        placement="right"
        open={visible}
        onClose={toggle}
        width={530}
        getContainer={() => document.querySelector('.smartAccountWrapper') || document.body}
        extra={(
          <span onClick={toggle} onKeyPress={toggle} tabIndex={0} role="button" aria-label="close" className="close-alerts"><CloseAlerts /></span>
        )}
      >
        {loadingIds.includes(companyIdParsed)
          ? <SmartAccountPlanPreparingLoader /> : null}
        {shouldShowAetnaSelection
          ? (
            <SmartAccountAetnaSelection
              companyId={companyIdParsed}
              defaultSelectedCompanyId={userCompanyId}
              setMappedCompanyId={setMappedCompanyId}
              setShowAccountPlanForm={setShowAccountPlanForm}
              companiesData={aetnaSubsidiaryCompanies}
              onCloseAetnaScreen={() => setAetnaSelectionDismissed(true)}
              showBackButton={sapInitialized}
              onBack={() => {
                dispatch(actions.setShowSAPHistory(true));
                dispatch(actions.clearAccountPlanForm());
              }}
            />
          ) : null}
        {!shouldShowAetnaSelection && (
          (!loadingIds.includes(companyIdParsed) && currentSapCompanyId !== companyIdParsed)
            || generationFail
            ? !showAccountPlanForm
              ? (
                <SmartAccountSplashScreen
                  companyId={companyIdParsed}
                  setShowAccountPlanForm={setShowAccountPlanForm}
                  sapInitialized={sapInitialized}
                />
              )
              : (
                <SmartAccountPlanSlider
                  selectedCompanyId={effectiveCompanyId}
                  sliderData={accountPlanForm}
                  companyName={companyName}
                  handleNewSapForm={handleNewAccountPlan}
                />
              )
            : currentSapCompanyId === companyIdParsed
              ? (
                <SmartPlanDocumentReady
                  handleNewAccountPlan={handleNewAccountPlan}
                  companyId={companyIdParsed}
                  setDrawerOpen={setDrawerViewerOpen}
                  handleAllowPop={handleAllowPop}
                  drawerOpen={drawerViewerOpen}
                />
              ) : null
        )}
      </Drawer>
      {
        showLimitPopupSAP && limitPopup?.showPlanPopup === 3
          ? (
            <ProfilePopups
              title={limitPopup?.downloadPopupHeading}
              description={limitPopup?.downloadPopupText}
              type={limitPopup?.showPlanPopup}
              callToAction={limitPopup?.callToAction}
              contactUs={limitPopup?.contactusEmail}
              isDownloadPopup={false}
              loading={false}
              isSAP
            />
          ) : null
      }
    </Wrapper>
  );
};

export default DrawerSmartAccount;